import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <LatestUpdates />
      </main>
      <Footer />
    </div>
  );
}